import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterControls = ({ activeFilter, onFilterChange, activeSort, onSortChange }) => {
  const filters = [
    { id: 'all', label: 'All Gems', icon: 'Grid3x3' },
    { id: 'common', label: 'Common', icon: 'Gem' },
    { id: 'rare', label: 'Rare', icon: 'Diamond' },
    { id: 'epic', label: 'Epic', icon: 'Crown' },
    { id: 'legendary', label: 'Legendary', icon: 'Sparkles' }
  ];

  const sortOptions = [
    { id: 'date-desc', label: 'Newest First', icon: 'ArrowDown' },
    { id: 'date-asc', label: 'Oldest First', icon: 'ArrowUp' },
    { id: 'rarity-desc', label: 'Rarity High-Low', icon: 'TrendingUp' },
    { id: 'rarity-asc', label: 'Rarity Low-High', icon: 'TrendingDown' }
  ];

  return (
    <div className="filter-controls bg-card border-2 border-primary rounded-sm p-4 md:p-6 shadow-glow-cyan-md">
      <div className="space-y-4 md:space-y-6">
        <div>
          <h3 className="font-heading font-semibold text-sm md:text-base text-primary mb-3 flex items-center gap-2">
            <Icon name="Filter" size={18} />
            Filter by Rarity
          </h3>
          <div className="flex flex-wrap gap-2">
            {filters?.map((filter) => (
              <Button
                key={filter?.id}
                variant={activeFilter === filter?.id ? 'default' : 'outline'}
                size="sm"
                iconName={filter?.icon}
                iconPosition="left"
                onClick={() => onFilterChange(filter?.id)}
                className="flex-shrink-0"
              >
                {filter?.label}
              </Button>
            ))}
          </div>
        </div>

        <div className="border-t border-primary/20 pt-4 md:pt-6">
          <h3 className="font-heading font-semibold text-sm md:text-base text-secondary mb-3 flex items-center gap-2">
            <Icon name="ArrowUpDown" size={18} />
            Sort Order
          </h3>
          <div className="grid grid-cols-2 gap-2">
            {sortOptions?.map((sort) => (
              <Button
                key={sort?.id}
                variant={activeSort === sort?.id ? 'secondary' : 'outline'}
                size="sm"
                iconName={sort?.icon}
                iconPosition="left"
                onClick={() => onSortChange(sort?.id)}
                fullWidth
              >
                <span className="hidden sm:inline">{sort?.label}</span>
                <span className="sm:hidden">{sort?.label?.split(' ')?.[0]}</span>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;